import { useQuery } from '@tanstack/react-query';

import { fetchUsersMe } from 'mrt-apis';

import { messengerKeys } from '~queryKeys/messengerKeys';

export async function fetchUsersMeQuery(isWebView = false) {
  const response = await fetchUsersMe({ isWebView })();
  return response?.data ?? null;
}

export default function useUsersMeQuery(isWebView = false) {
  return useQuery(messengerKeys.me(), () => fetchUsersMeQuery(isWebView));
}
